module.exports = __webpack_public_path__ + "img/bg-magento-find-out_small@2x.1d0f3be1.jpg";